import { Link } from "react-router-dom";

const SmartDealsBannerSection = () => {
  const marqueeItems = [
    "Built for the Community",
    "Experience More",
    "Deals That Matter",
    "Support Local",
    "Earn More",
  ];

  const brandLogos = [
    "/images/Webp/Brand1.webp",
    "/images/Webp/Brand2.webp",
    "/images/Webp/Brand3.webp",
    "/images/Webp/Brand4.webp",
    "/images/Webp/Brand5.webp",
    "/images/Webp/Brand6.webp",
    "/images/Webp/Brand7.webp",
    "/images/Webp/Brand8.webp",
    "/images/Webp/Brand9.webp",
    "/images/Webp/Brand10.webp",
    "/images/Webp/Brand11.webp",
  ];

  return (
    <section className="w-full flex justify-center lg:px-[80px] lg:-mt-[320px] ">
      <div className="
        relative
        w-full
        max-w-[1820px]
        h-[420px] lg:h-[680px]
        lg:rounded-[26px]
        overflow-hidden lg:mt-[120px]
        bg-gradient-to-b from-[#990000] via-[#E40000] to-[#FF0000]
      ">

        {/* MARQUEE TEXT */}
        <div
          aria-hidden="true"
          className="absolute top-[30px] lg:top-[60px] left-0 right-0 pointer-events-none"
        >
          <div className="flex items-center gap-[36px] opacity-90 animate-marquee">
            {[...marqueeItems, ...marqueeItems].map((text, i) => (
              <div key={i} className="flex items-center gap-[36px]">
                <span className="
                  font-semibold text-white
                  text-[42px] md:text-[82px] sm:text-[62px] lg:text-[100px]
                  tracking-[-3px]
                  leading-none whitespace-nowrap
                ">
                  {text}
                </span>
                {i !== marqueeItems.length - 1 && (
                  <div className="w-[10px] h-[10px] lg:w-[18px] lg:h-[18px] bg-white rounded-full flex-shrink-0" />
                )}
              </div>
            ))}
          </div>
        </div>

        {/* DIVIDER — desktop only */}
        <div className="
          hidden lg:block
          absolute top-[215px] left-1/2 -translate-x-1/2
          w-[1140px] h-[1px] bg-white/30
        " />

        {/* SUBTEXT */}
        <p className="
          absolute
          top-[130px] lg:top-[270px]
          left-1/2 -translate-x-1/2
          w-full px-6 lg:px-0 lg:w-auto
          text-white text-center
          text-[14px] lg:text-[30px]
          font-light tracking-[-0.5px]
          whitespace-nowrap
        ">
          100s of local and national brands at your fingertips.
        </p>

        {/* BRAND LOGOS */}
        <div
          aria-hidden="true"
          className="
            absolute
            top-[230px] lg:top-[380px]
            flex gap-[12px] lg:gap-[22px]
            items-center animate-marquee-reverse
          "
        >
          {[...brandLogos, ...brandLogos].map((src, i) => (
            <div
              key={i}
              className="
                w-[110px] h-[70px] lg:w-[200px] lg:h-[120px]
                bg-white
                rounded-[10px] lg:rounded-[18px]
                flex items-center justify-center flex-shrink-0
                shadow-[0px_30px_80px_rgba(0,0,0,0.25)]
              "
            >
              <img
                src={src}
                alt=""
                aria-hidden="true"
                className="max-h-[46px] max-w-[100px] lg:max-h-[100px] lg:max-w-[180px] object-contain"
              />
            </div>
          ))}
        </div>

        {/* BOTTOM LINK */}

        <p className="
          absolute
          bottom-[20px] lg:bottom-[34px]
          left-1/2 -translate-x-1/2
          text-center
          text-[12px] lg:text-[22px]
          underline whitespace-nowrap
        ">
          <Link to="/business" className="text-white hover:text-white visited:text-white">
            Own a business? Join our community – Free.
          </Link>
        </p>

        {/* SIDE GRADIENT FADES */}
        <div className="absolute left-0 top-0 h-full w-[50px] lg:w-[260px] bg-gradient-to-r from-[#990000] to-transparent pointer-events-none" />
        <div className="absolute right-0 top-0 h-full w-[50px] lg:w-[260px] bg-gradient-to-l from-[#990000] to-transparent pointer-events-none" />

        {/* GLOW */}
        <div className="
          absolute bottom-[100px] left-1/2 -translate-x-1/2
          w-[720px] h-[720px]
          bg-black/20 lg:bg-black/40
          rounded-full blur-[200px]
          pointer-events-none
        " />

      </div>
    </section>
  );
};

export default SmartDealsBannerSection;